import {
  GET_SAP_JOBS,
  CLEAR_JOBS,
} from '../constants/actionTypes';

const initialState = {
  jobs: [],
};

const importJob = (state = initialState, action) => {
  switch (action.type) {
    case GET_SAP_JOBS:
      return {...state, jobs: action.payload};
    case CLEAR_JOBS:
      return initialState;
    default:
      return state;
  }
}

export default importJob;



// WEBPACK FOOTER //
// ./src/reducers/reducer-importJob.js